export default __webpack_public_path__ + "static/media/lowFatNaturalYoghurt.9807963a.jpg";